<template>
	<div class="vstack gap-1">
		<div class="h5 fw-bold">Resúmen del cliente</div>
		<table class="table table-sm lh-sm align-top">
			<tbody>
				<tr v-if="'last_buy' in customer.extras">
					<td class="text-sm fw-bold" width="120">Última compra</td>
					<td class="text-sm text-end">{{ lastBuyFormatted }}</td>
				</tr>
				<tr v-if="'total_buy' in customer.extras">
					<td class="text-sm fw-bold" width="120">Compra total</td>
					<td class="text-sm text-end">{{ vueNumberFormat(customer.extras.total_buy, { precision: 2 }) }}</td>
				</tr>
				<tr v-if="'birthdate' in customer.extras">
					<td class="text-sm fw-bold" width="120">Cumpleaños</td>
					<td class="text-sm text-end">{{ birthdateFormatted }}</td>
				</tr>
				<tr v-if="'address' in customer.extras">
					<td class="text-sm fw-bold" width="120">Dirección</td>
					<td class="text-sm text-end">{{ customer.extras.address }}</td>
				</tr>
				<tr v-if="'register_online' in customer.extras">
					<td class="text-sm fw-bold" width="120">Tipo de registro</td>
					<td class="text-sm text-end">{{ (customer.extras.register_online) ? 'En tienda online' : 'En tienda física' }}</td>
				</tr>
				<tr v-if="customer.group">
					<td class="text-sm fw-bold" width="120">Grupo</td>
					<td class="text-sm text-end">{{ customer.group.name }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import moment from 'moment';

	export default {
		props: {
			customer: Object
		},
		setup(props) {
			const lastBuyFormatted = computed(() => moment(props.customer.extras?.last_buy).format('LL'));
			const birthdateFormatted = computed(() => moment(props.customer.extras?.birthdate).format('dddd D [de] MMMM'));

			return { lastBuyFormatted, birthdateFormatted };
		}
	}
</script>